module.exports = __webpack_public_path__ + "static/media/check.87cfde4a.svg";